import { modes } from './constants';

const presets = {

    ONLY_NUMBERS: {
        mask: '*',
        mode: modes.NORMAL,
    },

    DATE_STAMP: {
        mask: '????-??-??'
    },

    DATE_PTBR: {
        mask: '??/??/????'
    },

    DATETIME_STAMP: {
        mask: '????-??-?? ??:??:??',
    },

    DATETIME_PTBR: {
        mask: '??/??/???? ??:??',
    },

    PHONE_USA: {
        mask:   '(???) ???-????',
        mode:    modes.NORMAL,
    },

    PHONE_BR: {
        mask: ['(??) ?????-????', '(??) ????-????'],
        mode: modes.NORMAL,
    },

    CURRENCY_POINT: {
        mask:        '{3|,}.??',
        mode:        modes.REVERSE,
        placeholder: '0'
    },

    CURRENCY_COMMA: {
        mask:        '{3|.},??',
        mode:        modes.REVERSE,
        placeholder: '0'
    },

    CURRENCY_PTBR: {
        mask:        'R$ {3|.},??',
        mode:        modes.REVERSE,
        placeholder: '0'
    },

    DOCUMENT_CPF: {
        mask: '???.???.???-??',
        mode: modes.REVERSE,
    },

    DOCUMENT_CNPJ: {
        mask: '??.???.???/????-??',
        mode: modes.REVERSE,
    },

    DOCUMENT_CPF_CNPJ: {
        mask: ['???.???.???-??', '??.???.???/????-??'],
    },

    IP_V4: {
        mask: '???.???.???.???',
        mode: modes.NORMAL,
    }

}

export default presets;
